import type { FieldOpsPerson } from '../domain/fieldOpsPeople';
import { fieldOpsPeopleApi as liveApi } from './live-field-ops-people-api';
import { fieldOpsPeopleApi as mockApi } from './mock-field-ops-people-api';

/**
 * The Field Ops directory, backed by leatherback's
 * `Users.ListFieldOpsPeople` (`GET /v1/fieldOpsPeople`). Read-only: the
 * inventory UI uses it to prefill a new request's Source/Team from the
 * signed-in person -- see domain/fieldOpsPeople.ts. Editing who's tagged
 * is an admin operation on the leatherback `users` record.
 */
export interface FieldOpsPersonTagsPatch {
  email: string;
  version: number;
  source?: FieldOpsPerson['source'];
  team?: FieldOpsPerson['team'];
}

export interface FieldOpsPeopleApi {
  listFieldOpsPeople(): Promise<FieldOpsPerson[]>;
  /**
   * Set a person's Field Work source/team tags (admin only, version-checked
   * -- leatherback UpdateUser). Pass `undefined` to clear a tag.
   */
  updateFieldOpsPersonTags(patch: FieldOpsPersonTagsPatch): Promise<FieldOpsPerson>;
}

export const fieldOpsPeopleApi: FieldOpsPeopleApi =
  import.meta.env.VITE_API_MODE === 'live' ? liveApi : mockApi;
